import React from "react";
import useEmblaCarousel from "embla-carousel-react";
import { Link } from "@reach/router";

import { DotButton, useDotButton } from "./EmblaCarouselDotButton";
import {
  PrevButton,
  NextButton,
  usePrevNextButtons,
} from "./EmblaCarouselArrowButtons";

import { S3_ENDPOINT } from "../../utils";

const OPTIONS = { align: "start" };

const OnlineClassTypesCarousel = ({ class_types }) => {
  const [emblaRef, emblaApi] = useEmblaCarousel(OPTIONS);

  const { selectedIndex, scrollSnaps, onDotButtonClick } =
    useDotButton(emblaApi);

  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  } = usePrevNextButtons(emblaApi);

  return (
    <>
      <section className="embla online-class-types-embla">
        <div className="online-embla__track-row d-flex align-items-stretch w-100">
          <div className="online-embla__arrow-col d-flex align-items-center justify-content-center flex-shrink-0">
            <PrevButton onClick={onPrevButtonClick} disabled={prevBtnDisabled} />
          </div>
          <div className="embla__viewport flex-grow-1 min-w-0" ref={emblaRef}>
            <div className="embla__container">
            {class_types
              ?.filter((type) => type.file && type.file?.type && type.file?.name)
              ?.sort((a, b) => a.order - b.order)
              .map((type) => {
                const src =
                  type.file !== null
                    ? `${S3_ENDPOINT}/${type.file.name}.${type.file.type}`
                    : "";

                return (
                  <div className="online-embla__slide" key={type.class_type_id}>
                    <Link
                      to={`/class_type/${type.class_type_id}`}
                      className="online-embla__slide__card position-relative d-block text-decoration-none"
                      aria-label={`${type.name} — ver disciplina y beneficios`}
                    >
                      <img
                        alt=""
                        src={src}
                        className="w-100 h-100 position-absolute top-0 bottom-0 end-0 start-0"
                        style={{ objectFit: "cover" }}
                      />
                      <div className="online-embla__type-description gothic-font">
                        <h2 className="type-description__title mb-auto">
                          {type.name}
                        </h2>
                        <h2 className="type-description__videos mb-auto">
                          {type.videos.length} Videos
                        </h2>

                        <span className="btn py-0 px-0 btn-sm h-max-content d-inline-flex align-items-center">
                          Ver beneficios
                          <i className="fas fa-chevron-right ms-2" />
                        </span>
                      </div>
                    </Link>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="online-embla__arrow-col d-flex align-items-center justify-content-center flex-shrink-0">
            <NextButton onClick={onNextButtonClick} disabled={nextBtnDisabled} />
          </div>
        </div>

        <div className="online-embla__controls">
          <div className="online-embla__dots">
            {scrollSnaps.map((_, index) => (
              <DotButton
                key={index}
                onClick={() => onDotButtonClick(index)}
                className={"online-embla__dot".concat(
                  index === selectedIndex ? " online-embla__dot--selected" : ""
                )}
              />
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default OnlineClassTypesCarousel;
